import React from 'react';

import {Permissions} from 'auth/PermissionConstants';
import DataConnector from 'connect/DataConnector';
import {ProteinHistoryPanelState} from 'FileStates';
import Protein from 'molbio/proteins/Protein';
import ProteinActions from 'molbio/proteins/ProteinActions';
import ProteinStore from 'molbio/proteins/ProteinStore';
import {ProteinVersion} from 'molbio/proteins/util/ProteinConstants';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';
import HistoryPanelComponent from 'toolbar/shared/HistoryPanelComponent';

class ProteinHistoryPanelConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [ProteinStore];

  enhanceProps(): EnhancedProps {
    const protein = this.proteinStore().getProteinById(this.props.id)!;
    const versions = this.proteinStore().getVersionsById(this.props.id);
    const openVersionId = protein.version.id;
    const {isLatest} = protein;
    return {versions, openVersionId, isLatest};
  }
}

interface Props {
  id: string;
  permissions?: Permissions;
}

interface EnhancedProps {
  versions: Array<ProteinVersion>;
  openVersionId: number;
  isLatest: boolean;
}

class ProteinHistoryPanel extends React.Component<Props & EnhancedProps> {
  openVersion = (versionId: string | number): void => {
    ProteinActions.open(this.props.id, {versionId: versionId as number});
  };

  resetToVersion = (): void => {
    ProteinActions.revert(this.props.id, this.props.openVersionId);
  };

  override render(): JSX.Element {
    return (
      <HistoryPanelComponent
        openVersion={this.openVersion}
        resetToVersion={this.resetToVersion}
        versions={this.props.versions}
        openVersionId={this.props.openVersionId}
        isLatest={this.props.isLatest}
        unsaved={false}
        showNames={true}
        showSeconds={true}
        hasParent={false}
        parent={null}
        permissions={this.props.permissions}
        dirty={false}
      />
    );
  }
}

const ConnectedProteinHistoryPanel = ProteinHistoryPanelConnector.connect(ProteinHistoryPanel);

class ProteinHistoryPanelView extends ReactPanelBaseView<ProteinHistoryPanelState, Protein> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('history'),
        title: 'History',
        component: <ConnectedProteinHistoryPanel id={this.model.id} permissions={this.model.permissions()} />,
      },
    ];
  }
}

export default ProteinHistoryPanelView;
